import { createContext, type Dispatch } from 'react';

import { type ReducerState, type ReducerActions, blankState } from './SellerApplicationFormReducer';

const SellerOmtReturnReviewContext = createContext<{
    dispatch: Dispatch<ReducerActions>;
    state: ReducerState;
}>({
    dispatch: () => {},
    state: blankState,
});

export default SellerOmtReturnReviewContext;
